import { Flex, Icon, Text, TooltipWrapper } from "@theorgchartdev/storybook";
import React from "react";
import { appstr } from "@coreapp/utils/appstr";

export const ChangesPendingText = props => {
  return (
    <TooltipWrapper
      tooltipProps={{
        content: (
          <Flex gap={"12px"} alignItems={"center"}>
            <Text
              size={"xsmall"}
              colorModifier={"white"}
              style={{ textDecoration: "line-through" }}
            >
              {props.priorValue}
            </Text>
            <Icon size={"xsmall"} name={"arrow-right-solid"} modifier={"white"} />
            <Text size={"xsmall"} colorModifier={"white"}>
              {props.newValue}
            </Text>
          </Flex>
        )
      }}
    >
      <Text size="xsmall" colorModifier="lightgrey" modifier={"italic"}>
        {appstr("Changes pending")}
      </Text>
    </TooltipWrapper>
  );
};
